var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill"},[_vm._v(" "+_vm._s(_vm.playersCount)+" "+_vm._s(_vm.$tc("plural.player", _vm.playersCount || 1))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }